<template>
<!-- 推币充值 -->
<div>

  <MinappBannerAdvert class="mb16" />

  <pack class="main-pack">
    <zt-title class="mb8">账户充值</zt-title>
    <el-form class="info-form" label-width="94px" label-position="left">
      <el-form-item label="充值账号">
        <strong>{{ telephone | encryptPhone }}(自己)</strong>
      </el-form-item>
      <el-form-item label="账户推币">
        <strong class="tuibi">
          <svg-icon icon="tuibi" size="25" />{{ balance - 0 }}个
        </strong>
      </el-form-item>
    </el-form>
    <hr>

    <el-form class="rechange-form" @submit.native.prevent label-width="120px" label-position="left">
      <el-form-item label="推币充值">
        <el-input-number v-model="money" :min="1" />
        <span class="num">个/<span>{{ money }}</span>元</span>
        <p class="help">充值数量必须为整数</p>
      </el-form-item>
      <el-form-item label="充值渠道" class="mb36">
        <el-radio class="radio"><img :src="zfb"></el-radio>
      </el-form-item>
      <el-form-item>
        <zt-button type="primary" width="140px" @click="onSubmit" :loading="loading">立即充值</zt-button>
        <span class="tip">需支付{{ money }}元</span>
      </el-form-item>
    </el-form>
  </pack>

  <pack class="fx help-tip">
    <svg-icon icon="warn" size="45" class="mr16" />
    <div>
      <p class="help-title">温馨提示</p>
      <p>您的账户推币将通过第三方平台进行充值。</p>
    </div>
  </pack>

  <wating-dialog v-model="watingVisible" :orderno="orderno" :pay-url="pay_url"></wating-dialog>
</div>
</template>

<script>
import zfb from '@imgs/zfb.png'
import watingDialog from './dialogs/watingDialog'
import { taoke_charge } from '@/api/myCenter'
import { encryptPhone } from '@/filters/phone'
import { MinappBannerAdvert } from '@/components/Adverts'
export default {
  name: 'Rechange',
  components: { watingDialog, MinappBannerAdvert },
  filters: { encryptPhone },

  data: () => ({
    zfb,
    money: 100,
    loading: false,
    watingVisible: false,
    orderno: null,
    pay_url: null,

  }),

  computed: {
    telephone() {
      return this.$store.state.user.info.telephone
    },
    balance() {
      return this.$store.state.user.info.money_total
    },
  },

  methods: {

    // 提交充值
    async onSubmit() {
      this.loading = true
      const tempWindow = window.open()
      const { data } = await taoke_charge(this.money, location.href)
      try {
        if (data.error_code == 0) {
          this.orderno = data.orderno
          this.pay_url = data.pay_url
          tempWindow.location.href = data.pay_url
          this.watingVisible = true
        }
        else {
          tempWindow.close()
          this.$message.error(data.error_message)
        }
        this.loading = false
      }catch {
        this.$message.error('发生错误')
        tempWindow.close()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main-pack {
  padding: 22px 32px;
}

.info-form {
  .el-form-item {
    margin: 0;
  }

  .tuibi {
    display: flex;
    align-items: center;
  }

  .svg-icon {
    margin-right: 4px;
  }
}

.rechange-form {
  .num {
    display: inline-block;
    min-height: 40px;
    line-height: 40px;
    font-size: 18px;
    color: $theme-textnormal;
    vertical-align: middle;
    margin-left: 10px;

    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      font-size: 28px;
      margin: 0 5px;
    }
  }

  .radio {
    img {
      vertical-align: middle;
    }
  }
}

hr {
  border: none;
  border-top: 2px solid $theme-border4;
  margin: 4px 0 16px;
}

.el-input-number {
  /deep/ .el-input__inner {
    border-radius: 4px;
  }
}

.tip {
  display: inline-block;
  line-height: 44px;
  color: $theme;
}

.zt-button {
  padding: 10px 20px;
  margin-right: 16px;
}

.help-tip {
  padding: 32px;
  color: $theme-textsecond;
  font-size: 14px;

  .svg-icon--warn {
    color: $theme-gold;
  }

  .help-title {
    font-size: 16px;
    margin-bottom: 7px;
  }
}

.svg-icon--tuibi {
  color: #8D9299;
}
</style>
